export default "__VITE_ASSET__B_LeP5$3__"